import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {Observable} from 'rxjs';
import {EnvironmentService} from '../core/environment.service';

@Injectable({
    providedIn: 'root'
})
export class ScGuard  {
    private router = inject(Router);
    private environmentService = inject(EnvironmentService);


    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (!this.environmentService.systemUser || this.environmentService.systemUser.application !== 'MWS-SETUP') {
            this.router.navigate(['/']);
            return false;
        } else {
            return true;
        }
    }
}
